import type { NameNode } from 'graphql';
import { ApolloLink } from '@apollo/client';

type PrefixLinkFactoryProps = {
  name: string;
};

export const prefixIdentifier = (...strings: (string | null | undefined)[]) => {
  return strings.filter(Boolean).join('_');
};

export function createPrefixLink({ name }: PrefixLinkFactoryProps) {
  const renameNode = <T>(node: T, operationname?: string) => {
    const nodeName: NameNode = {
      kind: 'Name',
      value: prefixIdentifier(name, operationname),
    };

    return {
      ...node,
      name: nodeName,
    };
  };

  return new ApolloLink((operation, next) => {
    operation.operationName = prefixIdentifier(name, operation.operationName);
    operation.query = {
      ...operation.query,
      definitions: operation.query.definitions.map((node) => {
        if (node.kind === 'OperationDefinition') {
          return renameNode(node, node.name?.value);
        }

        return node;
      }),
    };
    return next(operation);
  });
}
